import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getQuotations = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/quotations?include=quotationItems,opportunity&' + params.toString()); // Let the error bubble up
};

const getQuotationById = async (id: number) => {
  return await apiClient.get(`/quotations/${id}`); // Fetch car listing by ID
};

const createQuotation = async (quotationData: any) => {
  return await apiClient.post('/quotations', quotationData); // Create a new car listing
};

const updateQuotation = async (id: number, quotationData: any) => {
  return await apiClient.patch(`/quotations/${id}`, quotationData); // Update car listing by ID
};

const deleteQuotation = async (id: number) => {
  return await apiClient.delete(`/quotations/${id}`); // Delete car listing by ID
};
/*
const getSoldByUser = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-by-user?' + params.toString()); // Let the error bubble up
};
const getSoldByMedium = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-by-medium?' + params.toString()); // Let the error bubble up
};
const getSoldByPoster = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-by-poster?' + params.toString()); // Let the error bubble up
};
const getSoldByProduct = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-by-product?' + params.toString()); // Let the error bubble up
};
const getQuotationsTotals = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/sold-totals?' + params.toString()); // Let the error bubble up
};
*/
export default {
  getQuotations,
  getQuotationById,
  createQuotation,
  updateQuotation,
  deleteQuotation,
  /*getSoldByUser,
  getSoldByMedium,
  getSoldByPoster,
  getSoldByProduct,
  getQuotationsTotals*/
};
